import type { Buyer } from '@shared/modules/buyers/buyer';
import { OrganisationPresenter } from '@shared/modules/organisations/organisation.presenter';
import { PersonPresenter } from '@shared/modules/people/person.presenter';
import { TeamPresenter } from '@shared/modules/teams/team-presenter';
import { Presenter } from '../../presenters/presenter';

export class BuyerPresenter extends Presenter<Buyer> {
    get name(): string {
        return this._get('name', () => this.person?.name ?? this.organisation?.name);
    }

    get person(): PersonPresenter {
        return this.present('person.data', PersonPresenter);
    }

    get organisation(): OrganisationPresenter {
        return this.present('organisation.data', OrganisationPresenter);
    }

    get email(): string {
        return this.person?.email ?? this.person?.emailWork ?? this.organisation?.email;
    }

    get teams(): TeamPresenter[] {
        return this.presentCollection('teams.data', TeamPresenter);
    }
}
